var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticStyle:{"text-align":"center","font-weight":"bold"}},[_vm._v(" 해운대 바다수온 ")]),_c('div',{ref:"chart",staticClass:"chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }